
import clsx from "clsx"
import type { ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function extractYouTubeVideoId(url: string): string {
  if (!url) return '';
  
  // Handle various YouTube URL formats
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  
  return (match && match[2].length === 11) ? match[2] : '';
}

// Function to format techniques array for display or storage
export function formatTechniquesArray(techniques: string | string[]): string[] {
  if (!techniques) return [];
  
  // If it's already an array, return it filtered
  if (Array.isArray(techniques)) {
    return techniques.filter(tech => tech && tech.trim().length > 0);
  }
  
  // If it's a string, split by commas and clean up
  if (typeof techniques === 'string') {
    return techniques
      .split(',')
      .map(t => t.trim())
      .filter(t => t.length > 0);
  }
  
  return [];
}

// Generate a unique ID for temporary objects
export function generateUniqueId(): string {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}
